import { render, staticRenderFns } from "./ContainerDetailView.vue?vue&type=template&id=58d704a3"
import script from "./ContainerDetailView.vue?vue&type=script&lang=js"
export * from "./ContainerDetailView.vue?vue&type=script&lang=js"
import style0 from "./ContainerDetailView.vue?vue&type=style&index=0&id=58d704a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports